import { createTheme } from "@mantine/core";

export const theme = createTheme({
  fontFamily: "'Inter', system-ui, -apple-system, sans-serif",
  primaryColor: "primary",
  colors: {
    primary: [
      "#fef2f2",
      "#fde8e8",
      "#fbd0d0",
      "#f8a9a9",
      "#f27a7a",
      "#e63946",
      "#d42f3c",
      "#b12533",
      "#8e1e29",
      "#751a24",
    ],
  },
});
